var {AmpersandState, AmpersandCollection} = require('catalog/libs');

/**
 * hit model
 */
var HitModel = AmpersandState.extend({
    props: {
        selectValue: 'string',
        selectLabel: 'string',
        isSelected: ['boolean', false, false]
    }
});

/**
 * hit model collection
 */
var HitsCollection = AmpersandCollection.extend({
    model: HitModel
});

/**
 * hit select model
 */
var HitSelectModel = AmpersandState.extend({

    props: {
        labelView: 'string',
        hitCount: 'string',
        hitsUIVisible: ['boolean', false, true]
    },

    collections: {
        hits: HitsCollection
    }
});

module.exports = HitSelectModel;
